"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireWildcard(require("react"));
var _HiButton = _interopRequireDefault(require("../HiButton"));
var _HiIcon = _interopRequireDefault(require("../HiIcon"));
var _Dialog = _interopRequireDefault(require("@mui/material/Dialog"));
var _DialogActions = _interopRequireDefault(require("@mui/material/DialogActions"));
var _DialogContent = _interopRequireDefault(require("@mui/material/DialogContent"));
var _DialogTitle = _interopRequireDefault(require("@mui/material/DialogTitle"));
var _material = require("@mui/material");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var HiAlertModal = function HiAlertModal(props) {
  var cancelButtonRef = (0, _react.useRef)(null);
  var submitButtonRef = (0, _react.useRef)(null);

  // Refs to HiButton to display focus state
  var submitActionsRef;
  var cancelActionsRef;

  // On Dialog opening, focus an action button
  var handleOnEntered = function handleOnEntered() {
    if (props.labelSubmitButton) {
      // Focus submit button
      submitButtonRef.current.focus();
      submitActionsRef.focusVisible();
    } else if (props.labelCancelButton) {
      // Focus cancel button
      cancelButtonRef.current.focus();
      cancelActionsRef.focusVisible();
    }
  };
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    className: props.className,
    classes: {
      paper: 'dialog-paper'
    },
    open: props.open,
    onClose: props.onClose,
    "aria-labelledby": "dialog-title",
    "aria-describedby": "dialog-content",
    TransitionProps: {
      onEntered: handleOnEntered
    }
  }, props.title && /*#__PURE__*/_react.default.createElement(_DialogTitle.default, {
    className: "dialog-title"
  }, props.title), /*#__PURE__*/_react.default.createElement(_DialogContent.default, {
    className: "dialog-content"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    component: "div",
    variant: "body2",
    color: "textSecondary"
  }, props.content)), /*#__PURE__*/_react.default.createElement(_DialogActions.default, {
    className: "dialog-actions"
  }, props.labelCancelButton && /*#__PURE__*/_react.default.createElement(_HiButton.default, {
    className: "cancel-button",
    onClick: props.onCancelClick,
    variant: props.cancelButtonVariant,
    color: props.cancelButtonColor,
    ref: cancelButtonRef,
    action: function action(actions) {
      cancelActionsRef = actions;
    }
  }, props.labelCancelButton), props.labelSubmitButton && /*#__PURE__*/_react.default.createElement(_HiButton.default, {
    className: "submit-button",
    onClick: props.onSubmitClick,
    color: props.submitButtonColor,
    variant: props.submitButtonVariant,
    ref: submitButtonRef,
    action: function action(actions) {
      submitActionsRef = actions;
    }
  }, /*#__PURE__*/_react.default.createElement(_HiIcon.default, null, props.submitIcon), /*#__PURE__*/_react.default.createElement("span", {
    className: "submit-text"
  }, props.labelSubmitButton))));
};
var StyledHiAlertModal = (0, _styledComponents.default)(HiAlertModal).withConfig({
  displayName: "HiAlertModal__StyledHiAlertModal",
  componentId: "sc-dmfyat-0"
})([".dialog-paper{padding:32px;", "{width:560px;min-width:560px;padding:55px;}}text-align:center;.dialog-title{padding:0;margin-bottom:25px;h2{font-weight:300;}}.dialog-content{padding:0;margin-bottom:25px;white-space:pre-line;}.dialog-actions{padding:0;display:flex;justify-content:space-around;}.cancel-button{width:122px;}.submit-button{width:288px;.submit-text{margin-left:6px;}}", "{.dialog-actions{flex-direction:column-reverse;justify-content:center;flex-wrap:wrap;padding:0;}.submit-button{width:100%;margin-bottom:16px;margin-left:0;}.cancel-button{width:100%;}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up('sm');
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.down('sm');
});
HiAlertModal.defaultProps = {
  cancelButtonColor: 'neutral',
  cancelButtonVariant: 'containedLight',
  submitButtonColor: 'primary',
  submitButtonVariant: 'contained',
  submitIcon: 'done'
};
var _default = exports.default = StyledHiAlertModal;